import type { DocStatus } from "../api.js";

const STYLE: Record<DocStatus | "active" | "completed" | "cancelled_case", React.CSSProperties> = {
  draft:          { background: "#f1f5f9", color: "#475569" },
  issued:         { background: "#dbeafe", color: "#1d4ed8" },
  cancelled:      { background: "#fee2e2", color: "#b91c1c" },
  active:         { background: "#dcfce7", color: "#15803d" },
  completed:      { background: "#e0e7ff", color: "#4338ca" },
  cancelled_case: { background: "#f1f5f9", color: "#64748b" },
};

const LABEL: Record<string, string> = {
  draft: "下書き", issued: "発行済み", cancelled: "取消済み",
  active: "進行中", completed: "完了", cancelled_case: "中止",
};

export function StatusBadge({ status }: { status: string }) {
  const key = status === "cancelled" ? (LABEL[status] ? status : "cancelled_case") : status;
  const style = STYLE[key as keyof typeof STYLE] ?? STYLE.draft;
  return (
    <span style={{
      display: "inline-block",
      padding: "2px 10px",
      borderRadius: 99,
      fontSize: 12,
      fontWeight: 600,
      ...style,
    }}>
      {LABEL[status] ?? status}
    </span>
  );
}
